import '../styles/PageGlobal.css';
import './MandatDetailsEditPage.css';
import React, { useState, useEffect, useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import ReferenceButton from '../components/ReferenceButton';
import ProduitsPicker from '../components/ProduitsPicker';
import { MandatService } from '../services/MandatService.js';
import { GestionStockService } from '../services/GestionStockService.js';  
import { AdresseService } from '../services/AdresseService.js';
import { ClientService } from '../services/ClientService.js';
import { BCCService } from '../services/BCCService.js';
import { DevisService } from '../services/DevisService.js';

   //for two type of adresses
  const ADDRESS_TYPES = {
  LIVRAISON: 'LIVRAISON',     
  FACTURATION: 'FACTURATION',
};

const formatAddress = (a) => {
  if (!a) return 'N/A';
  return [
    a.adresse1,
    a.adresse2,
    a.codePostal && a.ville ? `${a.codePostal} ${a.ville}` : (a.ville || a.codePostal),
    a.pays,
  ].filter(Boolean).join(', ') || 'N/A';
};


export default function MandatDetailsEditPage() {
  const { mandat_id } = useParams();
  
  // 🟢 Utilisation de useMemo pour éviter de recréer l'instance à chaque rendu
  const mandatService = useMemo(() => new MandatService(), []);
  const adresseService = useMemo(() => new AdresseService(), []);
   const stockService = useMemo(() => new GestionStockService(), []);
  const clientService = useMemo(() => new ClientService(), []);
  const bccService = useMemo(() => new BCCService(), []);
const devisService = useMemo(() => new DevisService(), []);

  const [mandat, setMandat] = useState(null);
  const [lignes, setLignes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editingLigne, setEditingLigne] = useState(null);

  // 🟢 État pour afficher/masquer le sélecteur de produits
  const [showProductPicker, setShowProductPicker] = useState(false);

 const [addresses, setAddresses] = useState([]);
const [livraisonId, setLivraisonId] = useState('');
const [facturationId, setFacturationId] = useState('');



  // ── CORRECTION 1 : Gestion complète du chargement et des erreurs ────────────
     const fetchMandatData = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await mandatService.fetchMandat(mandat_id);
      let finalMandatData = { ...data };

      // 🟢 1. Récupérer le NOM du client
      if (!finalMandatData.clientNom && finalMandatData.clientId) {
        const clientData = await clientService.getClientById(finalMandatData.clientId);
        if (clientData) {
          finalMandatData.clientNom = clientData.societe1;
          finalMandatData.clientTelephone = clientData.telephone;
        }
      }

      // 🟢 2. Récupérer le BCC (premier appel)
      if (!finalMandatData.bccIdDisplay && finalMandatData.clientId) {
        const bccData = await bccService.getBCCByClientId(finalMandatData.clientId);
        
        if (bccData) {
          finalMandatData.bccIdDisplay = bccData.id;
          
          // 🟢 3. Récupérer le Devis lié via le devisId du BCC
          if (bccData.devisId) {
            const devisData = await devisService.getDevisById(bccData.devisId);
            if (devisData) {
              finalMandatData.devisIdDisplay = devisData.id;
              finalMandatData.devisAdresseLivraisonId = devisData.adresseLivraisonId;
              finalMandatData.devisDate = devisData.createdAt;
            }
          }
        }
      }

      // Récupérer l'adresse
     // 4. Récupérer toutes les adresses du client + pré-sélection
      if (finalMandatData.clientId) {
        const list = await adresseService.fetchAllAddressesByClientId(finalMandatData.clientId);
        setAddresses(list);

        // Priorité : choix enregistré > adresse du devis > premier match par type
        const livraison =
          list.find((a) => a.id === finalMandatData.adresseLivraisonId) ||
          list.find((a) => a.id === finalMandatData.devisAdresseLivraisonId) ||
          list.find((a) => a.type === ADDRESS_TYPES.LIVRAISON);
        const facturation =
          list.find((a) => a.id === finalMandatData.adresseFacturationId) ||
          list.find((a) => a.type === ADDRESS_TYPES.FACTURATION);

        setLivraisonId(livraison ? String(livraison.id) : '');
        setFacturationId(facturation ? String(facturation.id) : '');
      }

      // 🟢 5. Récupérer le stock des lignes
      const rawLignes = finalMandatData.lines || finalMandatData.lignes || [];
      const lignesWithStock = await Promise.all(
        rawLignes.map(async (ligne) => {
          if (ligne.refFabricant) {
            const stock = await stockService.fetchStockByRefFabricant(ligne.refFabricant);
            return { ...ligne, stockDisponible: stock };
          }
          return { ...ligne, stockDisponible: 0 };
        })
      );
      
      setMandat(finalMandatData);
      setLignes(lignesWithStock); 
    } catch (err) {
      console.error('Error fetching mandat data:', err);
      setError(err.message || 'Erreur lors du chargement du mandat');
    } finally {
      setLoading(false);
    }
  }, [mandat_id, mandatService, stockService, adresseService, clientService, bccService, devisService]);


  useEffect(() => {
    fetchMandatData();
  }, [fetchMandatData]);

  // ── Action handlers ─────────────────────────────────────────────────────────
 
  const handleSendBeepoNote = async () => {
    try {
      // await mandatService.sendBeepoNote(mandat_id);
      alert('Envoi vers BeepoNote-Proforma (à implémenter)');
    } catch (err) {
      setError(err.message);
    }
  };

  // 🟢 CORRECTION 2 : Appel réel au service avec gestion d'erreur
  const handleClotureMandat = async () => {
  if (!livraisonId || !facturationId) {
    alert('Choisissez une adresse de livraison et de facturation avant la clôture.');
    return;
  }
  if (!window.confirm('Confirmer la clôture définitive du mandat ?')) return;
  try {
    // enregistrer le choix avant de clôturer
    await mandatService.updateAdresseLivraison(mandat_id, livraisonId);
    await mandatService.updateAdresseFacturation(mandat_id, facturationId);

    await mandatService.closeMandat(mandat_id);
    alert('Mandat clôturé avec succès !');
    await fetchMandatData();
  } catch (err) {
    console.error('Error clôture mandat:', err);
    setError(err.message);
  }
};

 

   // 🟢 1. Ouvrir le modal en préparant la quantité à attribuer
  const handleEditLigne = (ligneId) => {
    const ligne = lignes.find(l => l.id === ligneId);
    if (!ligne) return;
    
    setEditingLigne({ 
      ...ligne, 
      // On initialise la valeur du formulaire avec la quantité déjà attribuée
      newAttributedQty: ligne.quantityPartAttributed || 0 
    });
  };

  
 // 🟢 3. Quand l'utilisateur modifie la quantité dans le modal "Éditer"
  // Appelle addProdToLine (qui gère le delta +/- via stockService.attribute)
  const handleSaveLigne = async (updatedLigne) => {
    try {
      const newAttributed = Number(updatedLigne.newAttributedQty);
      
      // On envoie la nouvelle quantité à attribuer. 
      // (Note : Si vous souhaitez aussi que le backend mette à jour la quantité totale demandée, assurez-vous que votre DTO et service backend le gèrent)
      await mandatService.addProdToLine(mandat_id, {
        productId: updatedLigne.productId,
        refFabricant: updatedLigne.refFabricant,
        quantity: newAttributed
      });

      setEditingLigne(null);
      await fetchMandatData();
      alert('Ligne mise à jour avec succès !');
    } catch (err) {
      console.error('Error adjusting line:', err);
      setError(err.message);
    }
  };

  // 🟢 2. Quand l'utilisateur clique sur "Supprimer" dans le tableau (Modal Mandat)
  // Appelle removeLine (Libère stock + Supprime la ligne)
  const handleSupprimerLigne = async (ligneId) => {
    if (!window.confirm('Confirmer la suppression ? Le stock sera automatiquement libéré si nécessaire.')) return;
    try {
      await mandatService.removeLineFromMandat(ligneId);
      alert('Ligne supprimée et stock mis à jour.');
      await fetchMandatData();
    } catch (err) {
      console.error('Error removing line:', err);
      setError(err.message);
    }
  };

  
  // 🟢 Ouvre le picker existant
  const handleAjouterProduit = () => {
    setShowProductPicker(true);
  };

  // 🟢 Produits déjà présents dans le mandat
  const existingProductIds = useMemo(() => {
  return lignes
      .map(ligne => ligne.productId)
      .filter(Boolean);
  }, [lignes]);


  
// 🟢 1. Quand l'utilisateur sélectionne des produits dans le picker
  const handleProductsSelected = async (selectedProducts) => {
    try {
      if (!selectedProducts || selectedProducts.length === 0) {
        setShowProductPicker(false);
        return;
      }

      for (const product of selectedProducts) {
   
        console.log("📦 Produit brut reçu du picker :", product);
        const lineData = {
          productId: product.id,
          refFabricant: product.refFabricant,
          quantity: product.quantity || product.quantite || 1

        };
        
        console.log("📦 Produit brut du picker :", product);
        console.log("📤 JSON envoyé au backend :", JSON.stringify(lineData));
        
        // Étape A : Créer la ligne (OPEN, quantityPartAttributed = 0)
        await mandatService.createLine(mandat_id, lineData);
        
        // Étape B : Attribuer le stock immédiatement
        await mandatService.addProdToLine(mandat_id, lineData);
      }

      setShowProductPicker(false);
      await fetchMandatData();
      alert('Produit(s) ajouté(s) et stock attribué avec succès !');

    } catch (err) {
      console.error('Error adding product:', err);
      setError(err.message);
    }
  };

const handleSaveAddresses = async () => {
  try {
    if (livraisonId) await mandatService.updateAdresseLivraison(mandat_id, livraisonId);
    if (facturationId) await mandatService.updateAdresseFacturation(mandat_id, facturationId);
    alert('Adresses enregistrées !');
    await fetchMandatData();
  } catch (err) {
    alert('Erreur : ' + err.message);
  }
};

 const handleDownloadPdf = async (mandatId) => {
  try {
    const mandatService = new MandatService();
    await mandatService.downloadPdf(mandatId);
  } catch (err) {
    alert("Erreur téléchargement PDF : " + err.message);
  }
};

  const handlePrefacture = async (prefactureId) => {
    try {
      // await mandatService.generatePrefacture(mandat_id, prefactureId);
      alert(`Génération préfacture ${prefactureId} (à implémenter)`);
    } catch (err) {
      setError(err.message);
    }
  };

  // Calculate totals
  const totalHT = lignes.reduce((sum, ligne) => sum + ((ligne.unitPrice || 0) * (ligne.quantity || 0)), 0);
  const totalTVA = lignes.length > 0 ? (lignes[0].tva || 0) : 0;


  // ── Render guards ────────────────────────────────────────────────────────────
  if (loading) return <div className="mandat-status mandat-status-loading">Chargement…</div>;
  if (error) return (
    <div className="mandat-status mandat-status-error">
      <p>{error}</p>
      <ReferenceButton onClick={() => { setError(null); fetchMandatData(); }}>Réessayer</ReferenceButton>
    </div>
  );
  if (!mandat) return <div className="mandat-status mandat-status-error">Mandat non trouvé</div>;

  // ── Render ──────────────────────────────────────────────────────────────────
  return (
    <div className="containerMain mandat-container">
      {/* Header */}
      <div className="mandat-header">
        <div className="mandat-header-left">
          <h1 className="mandat-title">Mandat N°{mandat.id}</h1>
          <p className="mandat-protected">Ceci est un contenu protégé</p>
          {process.env.NODE_ENV === 'development' && (
            <p style={{ color: "red", margin: 0, fontSize: '0.8rem' }}>
              DEBUG mandat_id: {mandat_id}
            </p>
          )}
        </div>
        <div className="mandat-header-right">
          <button className="mandat-btn mandat-btn-print" 
                  onClick={() => handleDownloadPdf(mandat.id)}>
            Imprimer le mandat
          </button>
        </div>
      </div>

      {/* Top Action Buttons */}
      <div className="mandat-actions-top">
        
        <ReferenceButton onClick={handleClotureMandat} className="mandat-action-btn">
          Clôture déf. du mandat/bon de com client
        </ReferenceButton>
        <ReferenceButton onClick={handleSendBeepoNote} className="mandat-action-btn">
          Envoi vers BeepoNote-Proforma
        </ReferenceButton>
      </div>

            {/* Main Table */}
         {/* Main Table */}
      <div className="mandat-table-wrapper">
        <table className="mandat-table">
          <thead>
            <tr>
              <th>N</th>
              <th>Désignation</th>
              <th>Ref Fabricant</th>
              <th>Stock Dispo</th>
              <th>Quantité</th>
              <th>Prix HT</th>
              <th>TVA</th>
              <th>Statut</th>
              <th>Closed date</th>
              <th>Éditer/Supprimer</th>
            </tr>
          </thead>
          <tbody>
            {lignes.map((ligne, index) => (
              <tr key={ligne.id} className={editingLigne?.id === ligne.id ? 'editing' : ''}>
                <td>{index + 1}</td>
                <td className="mandat-designation">{ligne.reference}</td>
                <td>{ligne.refFabricant}</td>
                <td style={{ fontWeight: 'bold', color: (ligne.stockDisponible || 0) > 0 ? 'green' : 'red' }}>
                  {ligne.stockDisponible || 0}
                </td>
                <td>{ligne.quantity}</td>
                <td>{ligne.unitPrice} €</td>
                <td>
                  <span className="mandat-tva-badge">&lt; {ligne.tva || 0} %&gt;</span>
                </td>
                <td>{ligne.status}</td>
               <td>{mandat.createdAt ? new Date(mandat.createdAt).toLocaleDateString('fr-FR') : 'N/A'}</td>
                <td className="mandat-action-cell">
                  <button 
                    className="mandat-btn mandat-btn-edit" 
                    onClick={() => handleEditLigne(ligne.id)}
                    disabled={mandat?.status === 'CLOSED'}
                  >
                    Éditer
                  </button>
                  <button 
                    className="mandat-btn mandat-btn-delete" 
                    onClick={() => handleSupprimerLigne(ligne.id)}
                    disabled={mandat?.status === 'CLOSED'}
                  >
                    Supprimer
                  </button>
                </td>
              </tr>
            ))}
            
            <tr className="mandat-total-row">
              <td colSpan="5" className="mandat-total-label">TOTAL</td>
              <td>{totalHT.toFixed(2)} €</td>
              <td><span className="mandat-tva-badge">{totalTVA} %</span></td>
              <td colSpan="3"></td>
            </tr>
          </tbody>
        </table>
      </div>

      {/* Prefacture Buttons */}
      {mandat.prefactures && mandat.prefactures.length > 0 && (
        <div className="mandat-prefactures">
          <span className="mandat-prefacture-label">Préfactures :</span>
          {mandat.prefactures.map((prefacture) => (
            <button
              key={prefacture.id}
              className="mandat-btn mandat-btn-prefacture"
              onClick={() => handlePrefacture(prefacture.id)}
            >
              Préfacture #{prefacture.id} {prefacture.date}
            </button>
          ))}
        </div>
      )}

          
           {/* Client Information */}
      <div className="mandat-client-info">
        <div className="mandat-info-row">
          <span className="mandat-info-label">Nom client :</span>
          <span className="mandat-info-value">
            <span className="mandat-info-value">
             {mandat.clientNom || `ID: ${mandat.clientId}`}</span>
          </span>
        </div>
        
        <div className="mandat-info-row">
          <span className="mandat-info-label">Bon de commande client (BCC) :</span>
          <span className="mandat-info-value">
            {mandat.bccIdDisplay ? `N° ${mandat.bccIdDisplay}` : (mandat.bcfId ? `N° ${mandat.bcfId}` : 'N/A')}
          </span>
        </div>

        {/* 🟢 VERSION SIMPLE ET SUR UNE SEULE LIGNE */}
        <div className="mandat-info-row">
          <span className="mandat-info-label">Devis lié :</span>
          <span className="mandat-info-value">
            {mandat.devisIdDisplay 
              ? `N° ${mandat.devisIdDisplay} (Livraison: ${mandat.devisAdresseLivraisonId || 'N/A'}) - ${mandat.devisDate ? new Date(mandat.devisDate).toLocaleDateString('fr-FR') : 'N/A'}`
              : 'N/A'}
          </span>
        </div>

     <div className="mandat-addresses">
  {[
    { title: '📦 Adresse de livraison', type: ADDRESS_TYPES.LIVRAISON, value: livraisonId, set: setLivraisonId },
    { title: '🧾 Adresse de facturation', type: ADDRESS_TYPES.FACTURATION, value: facturationId, set: setFacturationId },
  ].map(({ title, type, value, set }) => {
    const options = addresses.filter((a) => a.type === type);
    const selected = addresses.find((a) => String(a.id) === value);
    return (
      <div className="mandat-address-card" key={title}>
        <span className="mandat-address-title">{title}</span>
        <select
          className="mandat-address-select"
          value={value}
          onChange={(e) => set(e.target.value)}
          disabled={mandat?.status === 'CLOSED'}
        >
          <option value="">-- Choisir --</option>
          {options.map((a) => (
            <option key={a.id} value={a.id}>{formatAddress(a)}</option>
          ))}
        </select>
        <span className="mandat-address-text">{formatAddress(selected)}</span>
      </div>
    );
  })}
</div>

<div className="mandat-info-row">
  <button
    className="mandat-btn mandat-btn-save"
    onClick={handleSaveAddresses}
    disabled={mandat?.status === 'CLOSED'}
  >
    💾 Enregistrer les adresses
  </button>
</div>

        <div className="mandat-info-row">
          <span className="mandat-info-label">Téléphone du client :</span>
          <span className="mandat-info-value">{mandat.clientTelephone || 'N/A'}</span>
        </div>
        
        <div className="mandat-info-row">
          <span className="mandat-info-label">Date de création :</span>
          <span className="mandat-info-value">
            {mandat.createdAt ? new Date(mandat.createdAt).toLocaleDateString('fr-FR') : 'N/A'}
          </span>
        </div>
        
        <div className="mandat-info-row">
          <button 
            className="mandat-btn mandat-btn-add-product" 
            onClick={handleAjouterProduit}
            disabled={mandat?.status === 'CLOSED'}
          >
            {mandat?.status === 'CLOSED' ? '🔒 Mandat clôturé' : '+ Ajouter un produit au mandat'}
          </button>
        </div>
      </div>
      
           {/* 🟢 Modal de Gestion de Ligne (Édition + Attribution) */}
      {/* 🟢 Modal d'Attribution Directe du Stock */}
      {editingLigne && (
        <div className="mandat-modal-overlay">
          <div className="mandat-modal" style={{ maxWidth: '500px' }}>
            <h3>Attribuer du stock à la ligne #{editingLigne.id}</h3>
            
            <div className="mandat-modal-form">
              <p style={{ marginBottom: '20px', paddingBottom: '10px', borderBottom: '1px solid #eee' }}>
                <strong>Produit :</strong> {editingLigne.reference || 'N/A'} <br/>
                <span style={{ color: '#666', fontSize: '0.9em' }}>Ref. Fabricant : {editingLigne.refFabricant || 'N/A'}</span>
              </p>
              
              {/* 🟢 AFFICHAGE DU STOCK DISPONIBLE EN TEMPS RÉEL */}
              <div style={{ marginBottom: '15px', padding: '10px', backgroundColor: '#e7f3ff', borderRadius: '4px', border: '1px solid #b3d7ff' }}>
                <span style={{ fontWeight: 'bold', color: '#004085' }}>
                  Stock disponible : {editingLigne.stockDisponible ?? 0}
                </span>
              </div>

              {/* 🟢 QUANTITÉ À ATTRIBUER DIRECTEMENT (Limitée au stock disponible) */}
              <label style={{ display: 'block', marginBottom: '15px' }}>
                <span style={{ fontWeight: 'bold', color: '#0056b3', display: 'block', marginBottom: '5px' }}>
                  Quantité à attribuer :
                </span>
                <input 
                  type="number" 
                  value={editingLigne.newAttributedQty ?? 0}
                  onChange={(e) => {
                    const val = Number(e.target.value);
                    const maxStock = editingLigne.stockDisponible ?? 999999;
                    // 🟢 Empêche de saisir plus que le stock disponible ou moins que 0
                    if (val >= 0 && val <= maxStock) {
                      setEditingLigne({...editingLigne, newAttributedQty: val});
                    }
                  }}
                  min="0"
                  max={editingLigne.stockDisponible ?? 999999}
                  className="mandat-input"
                  style={{ width: '100%', padding: '10px', borderRadius: '4px', border: '2px solid #007bff', fontSize: '1.1em', fontWeight: 'bold', textAlign: 'center' }}
                />
              </label>

              {/* 🟢 Feedback visuel simple */}
              <div style={{ 
                marginTop: '10px', 
                padding: '10px', 
                borderRadius: '4px',
                backgroundColor: '#d4edda',
                color: '#155724',
                fontSize: '0.9em',
                fontWeight: 'bold'
              }}>
                Cette quantité sera directement déduite du stock global et ajoutée à cette ligne.
              </div>
            </div>

            <div className="mandat-modal-actions" style={{ marginTop: '20px', display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button 
                className="mandat-btn mandat-btn-cancel" 
                onClick={() => setEditingLigne(null)}
              >
                Annuler
              </button>
              <button 
                className="mandat-btn mandat-btn-save" 
                onClick={() => handleSaveLigne(editingLigne)}
              >
                💾 Enregistrer l'attribution
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 🟢 Product Picker */}
      {showProductPicker && (
        <ProduitsPicker
          onClose={() => setShowProductPicker(false)}
          onSelect={handleProductsSelected}
          existingProductIds={existingProductIds}
        />
      )}
    </div>
  );
}